import React, {
  Suspense,
  use,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Mail,
  PhoneCall,
  CheckCircle,
  Copy,
  Pencil,
  Calendar,
  Clock,
  User,
  Plus,
  CopyCheck,
  Settings2,
  PanelLeft,
  ChevronLeft,
  PanelRight,
  X,
  Trash2,
  ThumbsUp,
  ThumbsDown,
  DollarSign,
  Key,
  ChartNoAxesCombined,
  ClipboardType,
  Receipt,
  UserRound,
} from "lucide-react";
import { Link, useLocation, useParams } from "react-router";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import Tooltip from "../../../../component/ui/tooltip";
// import FilesTab from "../../../../component/files";
import Style from "./style.module.css";
import Swal from "sweetalert2";
// import CommentsSection from "../../../../component/comment";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import { TableCard } from "../../../../component/table/table-layout";
import CustomizeTabsOverviewPopup from "./component/customize-tabs-popup";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import Chip from "../../../../component/ui/chip";
import StatusChip from "../../../../component/ui/chip/status";
import { RightSidebar } from "./component/right-side-bar";
import DealInfo from "./component/DealTab";
import ProjectTab from "./component/ProjectTab";
import Avatar from "../../../../component/ui/avatar";
import AvatarProfile from "../../../../component/ui/profile";
import { useClickOutside } from "../../../../component/custom-hooks/click-outside";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import FilesTab from "./component/files";
import Icon from "../../../../component/icons/inner-pages-icons";
import WonDeal from "../../deals/deal/won-deal/won-form-deal";
import LostDeal from "../../deals/deal/lost-deal/lost-form-deal";
import FollowUpPopup from "../follow-ups";
import CommentsSection from "../../../../component/comment";
import { FollowUpsTab, TimelineTab } from "../../../../component/ui/timeline";
import InvoiceQuickView from "../../../../component/invoice/InvoiceQuickView";
import { DynamicTable } from "../../../../component/Popup-comp";

const statusColor = {
  completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
  on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
  revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
  "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
  "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
  duplicate: { background: "#ede9fe", color: "#5b21b6" },
};
function Field({
  label,
  value,
  icon: Icon,
  copyable,
  link,
  endTag = false,
  LastElement,
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div
      className="grid grid-cols-12 items-center gap-2 rounded-xl border border-solid border-[rgba(0,0,0,0.08)] bg-white py-3 px-4 hover:translate-y-[-1px]  transition-all duration-200
    shadow-[0_1px_3px_rgba(0,0,0,0.06),_0_1px_2px_rgba(0,0,0,0.04)]
hover:shadow-[0_2px_8px_rgba(0,0,0,0.06),_0_1px_3px_rgba(0,0,0,0.04)]"
    >
      <div className="col-span-4 flex items-center gap-2 text-[13px] font-medium text-slate-500">
        {Icon ? <Icon className="size-4" /> : null}
        {label}
      </div>
      <div className="col-span-8 flex items-center justify-between gap-2 text-[13px] text-slate-800">
        {link ? (
          <a
            href={link}
            className="truncate underline decoration-slate-300 underline-offset-2 hover:text-blue-600 hover:decoration-blue-400"
          >
            {value}
          </a>
        ) : (
          <span className="truncate">{value}</span>
        )}
        {copyable || endTag ? (
          copyable ? (
            <button
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(String(value ?? ""));
                  setCopied(true);
                  setTimeout(() => setCopied(false), 1500);
                } catch {}
              }}
              className="inline-flex items-center gap-1 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100"
            >
              <Copy className="size-3.5" /> {copied ? "Copied" : "Copy"}
            </button>
          ) : (
            <LastElement />
          )
        ) : null}
      </div>
    </div>
  );
}

function TransactionField1({ tx }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (value) => {
    try {
      await navigator.clipboard.writeText(String(value ?? ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {}
  };

  return (
    <div
      className="grid grid-cols-12 items-center gap-2 rounded-xl border border-solid border-[rgba(0,0,0,0.08)] bg-white py-3 px-4
      hover:translate-y-[-1px] transition-all duration-200
      shadow-[0_1px_3px_rgba(0,0,0,0.06),_0_1px_2px_rgba(0,0,0,0.04)]
      hover:shadow-[0_2px_8px_rgba(0,0,0,0.06),_0_1px_3px_rgba(0,0,0,0.04)]"
    >
      {/* Transaction Key */}
      <div className="col-span-2 flex items-center gap-2 text-[13px] font-medium text-slate-500">
        <span className="truncate" title={tx.transactionkey}>
          {tx.transactionkey
            ? tx.transactionkey.length > 15
              ? tx.transactionkey.slice(0, 15) + "..."
              : tx.transactionkey
            : "-"}
        </span>

        {tx.transactionkey && (
          <button
            onClick={() => handleCopy(tx.transactionkey)}
            className="inline-flex items-center gap-1 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100"
          >
            {copied ? (
              <CopyCheck size={14} className="text-green-500" />
            ) : (
              <Copy size={14} />
            )}
          </button>
        )}
      </div>

      {/* Amount */}
      <div className="col-span-2 text-[13px] text-slate-800">${tx?.amount}</div>

      {/* Invoice ID */}
      <div className="col-span-2 text-[13px] text-slate-800">
        {tx?.invoice_id}
      </div>

      {/* Transaction Type */}
      <div className="col-span-2 text-[13px] text-slate-800">
        {tx?.transactiontype}
      </div>

      {/* Merchant */}
      <div className="col-span-2 text-[13px] text-slate-800">
        {tx?.merchant}
      </div>

      {/* Status */}
      <div className="col-span-2 flex items-center">
        <StatusChip
          color={
            tx?.transactionstatus === "success"
              ? "green"
              : tx?.transactionstatus === "pending"
                ? "blue"
                : "red"
          }
        >
          {tx?.transactionstatus}
        </StatusChip>
      </div>
    </div>
  );
}

function TransactionField({ tx }) {
  const [copied, setCopied] = useState(false);
  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceProjectKey, setInvoiceProjectKey] = useState("");

  const handleCopy = async (value) => {
    try {
      await navigator.clipboard.writeText(String(value ?? ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {}
  };

  return (
    <>
      <div
        className="grid grid-cols-12 items-center cursor-pointer gap-2 rounded-xl border border-solid border-[rgba(0,0,0,0.08)] bg-white py-3 px-4
      hover:translate-y-[-1px] transition-all duration-200
      shadow-[0_1px_3px_rgba(0,0,0,0.06),_0_1px_2px_rgba(0,0,0,0.04)]
      hover:shadow-[0_2px_8px_rgba(0,0,0,0.06),_0_1px_3px_rgba(0,0,0,0.04)]"
        onClick={() => {
          if (tx?.projectkey) {
            setInvoicePopup(true);
            setInvoiceProjectKey(tx?.projectkey);
          }
        }}
      >
        {/* Transaction Key */}
        <div className="col-span-3 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-medium">
            Transaction Key
          </span>
          <div className="flex items-center gap-2 justify-between ">
            <span className="truncate" title={tx.transactionkey}>
              {tx.transactionkey?.length > 15
                ? tx.transactionkey.slice(0, 15) + "..."
                : (tx.transactionkey ?? "-")}
            </span>
            {tx.transactionkey && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(tx.transactionkey);
                }}
                className="inline-flex items-center gap-1 z-20 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100"
              >
                <Copy className="size-3.5" /> {copied ? "Copied" : "Copy"}
              </button>
            )}
          </div>
        </div>

        {/* Amount */}
        <div className="col-span-2 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-semibold">
            Amount
          </span>
          <span className="text-[13px] text-slate-800">
            ${tx.amount || "-"}
          </span>
        </div>

        {/* Invoice ID */}
        <div className="col-span-2 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-medium">
            Invoice ID
          </span>
          <span className="text-[13px] text-slate-800">
            {tx.invoice_id || "-"}
          </span>
        </div>

        {/* Transaction Type */}
        <div className="col-span-2 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-medium">
            Method
          </span>
          <span className="text-[13px] text-slate-800">
            {tx.transactiontype || "-"}
          </span>
        </div>

        {/* Merchant */}
        <div className="col-span-2 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-medium">
            Merchant
          </span>
          <span className="text-[13px] text-slate-800">
            {tx.merchant || "-"}
          </span>
        </div>

        {/* Status */}
        <div className="col-span-1 flex flex-col gap-1">
          <span className="text-[10px] text-slate-400 uppercase font-medium">
            Status
          </span>
          <div>
            <StatusChip
              color={
                tx.transactionstatus === "success"
                  ? "green"
                  : tx.transactionstatus === "pending"
                    ? "blue"
                    : "red"
              }
            >
              {tx.transactionstatus}
            </StatusChip>
          </div>
        </div>
      </div>

      {invoicePopup && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceProjectKey(null);
          }}
          data={null}
          projectkey={invoiceProjectKey ? invoiceProjectKey : null}
          type="project"
        />
      )}
    </>
  );
}

const CopyIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div
        className="ms-2 hover:opacity-50 cursor-pointer transition-all"
        onClick={() => {
          copyToClipboard(text);
        }}
      >
        {isCopied ? (
          <CopyCheck size={15} color="#333" />
        ) : (
          <Copy size={15} color="#333" />
        )}
      </div>
    </>
  );
};

function NewField({ label, value, icon: Icon }) {
  const [isActive, setIsActive] = useState(false);
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return (
    <div>
      {isUrl ? (
        <>
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex gap-[10px] items-center">
              {Icon ? (
                <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
              ) : null}
              <p className="text-xs font-medium">{label}</p>
            </div>

            <div className="flex justify-between text-[14px] w-full font-normal text-[#999] min-w-0">
              <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
              >
                {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
              </a>

              <CopyIcon text={value} />
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-y-[10px]">
          <div className="flex gap-[10px] items-center">
            {Icon ? (
              <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
            ) : null}
            <p className="text-xs font-medium">{label}</p>
          </div>

          {/* <div className="text-sm font-medium text-[rgba(14,18,27,0.40)]">
            {value}
          </div> */}
          {/* Value */}
          <div className="text-sm font-medium text-[rgba(14,18,27,0.40)] break-words whitespace-normal">
            {displayText}

            {isLongText && (
              <button
                onClick={() => setShowAll(!showAll)}
                className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
              >
                {showAll ? "Show less" : "Show more"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const T = {
  bg: "#EDE8E1",
  sidebar: "#1a1730",
  sidebarHover: "#252240",
  sidebarActive: "#302d4a",
  card: "#FFFFFF",
  cardBorder: "rgba(0,0,0,0.08)",
  text: "#1a1520",
  textSecondary: "#5c5466",
  textMuted: "#908892",
  accent: "#6366f1",
  accentLight: "rgba(99,102,241,0.08)",
  accentText: "#5457e5",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  inputBg: "#F3EFE9",
  inputBorder: "rgba(0,0,0,0.1)",
};

// const STATUS_COLORS = {
//   "Need Analysis": "#f59e0b",
//   "Value Proposition": "#3b82f6",
//   "Identify Decision": "#8b5cf6",
//   Proposal: "#06b6d4",
//   Review: "#10b981",
//   "Closed Won": "#22c55e",
//   Won: "#22c55e",
//   "Closed Lost": "#ef4444",
//   Lost: "#ef4444",
// };
const STATUS_COLORS = {
  "Need Analysis": "#1A73E8",
  "Value Proposition": "#00838F",
  "Identify Decision": "#9333EA",
  Proposal: "#e65100",
  Review: "#6D4C41",
  "Closed Won": "#388e3c",
  Won: "#388e3c",
  "Closed Lost": "#b91c1c",
  Lost: "#b91c1c",
};

const ProjectStatusHEX = {
  completed: "#0F9D58", // emerald green
  on_hold: "#1A73E8", // royal blue
  pending: "#e65100", // deep orange
  in_progress: "#9333EA", // violet
  revision: "#00838F", // cyan / teal
  "no answer update 2": "#374151", // cyan / teal
  "wrong number": "#b91c1c", // cyan / teal
  "call back": "#78350f",
  "not interested": "#b91c1c", // cyan / teal
  "do not contact": "#374151", // cyan / teal
  duplicate: "#5b21b6",
};

const STAGES = [
  "Need Analysis",
  "Value Proposition",
  "Identify Decision",
  "Proposal",
  "Review",
];

// ─── HELPERS ───

const priorityColors = { high: "#ef4444", medium: "#f59e0b", low: "#10b981" };

// ─── COMPONENTS ───

const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);

const Card = ({ children, style = {}, hover = false, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setHovered(true)}
      onMouseLeave={() => hover && setHovered(false)}
      style={{
        background: T.card,
        border: `1px solid ${T.cardBorder}`,
        borderRadius: 12,
        boxShadow: hovered ? T.shadowMd : T.shadow,
        transform: hovered ? "translateY(-1px)" : "none",
        transition: "all 0.15s ease",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const ActionButton = ({
  icon,
  label,
  color = T.accent,
  variant = "outline",
  onClick,
  style = {},
}) => {
  const [hovered, setHovered] = useState(false);
  const filled = variant === "filled";
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 16px",
        borderRadius: 10,
        border: filled ? "none" : `1px solid ${color}30`,
        background: filled
          ? hovered
            ? color
            : color + "ee"
          : hovered
            ? color + "10"
            : color + "06",
        color: filled ? "#fff" : color,
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "inherit",
        transition: "all 0.15s",
        width: "100%",
        boxShadow: filled ? `0 2px 8px ${color}35` : "none",
        ...style,
      }}
    >
      <Icon name={icon} size={15} color={filled ? "#fff" : color} /> {label}
    </button>
  );
};

// ─── HEALTH GAUGE ───
const HealthGauge = ({ label, value, color }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <span style={{ fontSize: 12, color: T.textSecondary, minWidth: 110 }}>
      {label}
    </span>
    <div
      style={{
        flex: 1,
        height: 6,
        background: "#e8e5e0",
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: `${value}%`,
          height: "100%",
          borderRadius: 3,
          background: `linear-gradient(90deg, ${color}cc, ${color})`,
          transition: "width 0.5s ease",
        }}
      />
    </div>
    <span
      style={{
        fontSize: 12,
        fontWeight: 700,
        color,
        minWidth: 36,
        textAlign: "right",
      }}
    >
      {value}%
    </span>
  </div>
);

const getInitials = (name = "") => {
  return name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

function NewMetaField({ label, value }) {
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return isUrl ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0",
          borderBottom:
            // i < 6 ? `1px solid ${T.cardBorder}` : "none",
            `1px solid ${T.cardBorder}`,
        }}
      >
        <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

        <div className="flex justify-between font-mono text-[13px]  font-medium text-[#1a1520] min-w-0">
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
          >
            {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
          </a>

          <CopyIcon text={value} />
        </div>
      </div>
    </>
  ) : (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        borderBottom:
          // i < 6 ? `1px solid ${T.cardBorder}` : "none",
          `1px solid ${T.cardBorder}`,
      }}
    >
      <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

      {/* Value */}
      <div className="text-[13px]  font-medium text-[#1a1520] break-words whitespace-normal">
        {displayText || "-"}

        {isLongText && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
          >
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}

const Details = ({ leadDetail }) => {
  const campaignKeys = [
    "parent_url",
    "user_agent",
    "campaigned",
    "is_dropoff",
    "adgroupid",
    "keyword",
    "device",
    "matchtype",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ];

  const excludeKeys = [
    "name",
    "email",
    "phone",
    "lead_source",
    "leadstatus",
    "leadtime",
    "country",
    "date",
    "signuptime",
    "lead_converted_time",
  ];

  const campaignMeta = leadDetail?.meta?.filter((m) =>
    campaignKeys.includes(m.meta_key),
  );

  const otherMeta = leadDetail?.meta?.filter(
    (m) =>
      !campaignKeys.includes(m.meta_key) && !excludeKeys.includes(m.meta_key),
  );
  return (
    <>
      {/* Additonal  Information */}

      <div className="flex flex-col gap-y-[17px] w-full max-w-full">
        {/* <div className="bg-white   p-5 rounded-[10px] border border-[#E1E4EA]">
         
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex justify-between items-center">
              <p className="text-xl font-medium leading-normal">
                Additional Details
              </p>
            </div>

            <div className="grid grid-cols-3 gap-[15px] ">
              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <NewField
                  label="Industry"
                  value={leadDetail?.industry || "-"}
                />
                <NewField label="Source" value={leadDetail?.source || "-"} />
                <NewField
                  label="Created At"
                  value={leadDetail?.signupdate || "-"}
                />
              </div>

              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <NewField label="Badge" value={leadDetail?.badge || "-"} />
                <NewField
                  label="Page Source"
                  value={leadDetail?.page_source || "-"}
                />
                <NewField
                  label="Lead Converted Time"
                  value={leadDetail?.lead_converted_time || "-"}
                />
              </div>
            </div>
          </div>
        </div> */}

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}
        >
          <Card
            style={{
              padding: 20,
              maxHeight: "350px",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700 }}>
                Account Details
              </span>
            </div>
            {[
              { label: "Name", value: leadDetail?.name || "-" },

              {
                label: "Email",
                value: leadDetail?.email || "-",
                action: true,
                isUrl: true,
                url: `mailto:${leadDetail?.email}`,
              },
              {
                label: "Phone",
                value: leadDetail?.phone || "-",
                action: true,
                isUrl: true,
                url: `tel:${leadDetail?.phone}`,
              },
              { label: "Industry", value: leadDetail?.industry || "-" },
              { label: "Badge", value: leadDetail?.badge },
              // { label: "Source", value: leadDetail?.source || "-" },
              { label: "Page Source", value: leadDetail?.page_source || "-" },

              { label: "Date Created", value: leadDetail?.signuptime || "-" },
              {
                label: "Lead Converted Time",
                value: leadDetail?.lead_converted_time || "-",
              },
            ].map((field, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                }}
              >
                <span style={{ fontSize: 12, color: T.textMuted }}>
                  {field.label}
                </span>
                {field.badge ? (
                  <Badge color={field.color}>{field.value}</Badge>
                ) : (
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: field.highlight ? 700 : 500,
                      color: field.highlight
                        ? "#22c55e"
                        : field.action
                          ? T.accentText
                          : T.text,
                      fontFamily: field.mono ? "monospace" : "inherit",
                      fontSize: field.mono ? 11 : 13,
                      cursor: field.action ? "pointer" : "default",
                    }}
                  >
                    {field?.isUrl ? (
                      <a href={field?.url}>{field?.value}</a>
                    ) : (
                      field.value
                    )}
                  </span>
                )}
              </div>
            ))}
          </Card>
          {campaignMeta?.length > 0 || otherMeta?.length > 0 ? (
            <>
              {/* Other Information */}

              <Card
                style={{
                  padding: 20,
                  maxHeight: "350px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 16,
                  }}
                >
                  <span style={{ fontSize: 14, fontWeight: 700, zIndex: "10" }}>
                    Additional Information
                  </span>
                </div>
                <div
                  className="w-full h-full overflow-auto [scrollbar-width:none]
        [&::-webkit-scrollbar]:hidden
        [&_*::-webkit-scrollbar]:hidden
        [&_*]:[scrollbar-width:none]"
                  style={{
                    scrollbarGutter: "stable",
                    // paddingRight: "4px",
                  }}
                >
                  {campaignMeta?.length > 0
                    ? campaignMeta?.map((field, i) => (
                        // <div
                        //   key={i}
                        //   style={{
                        //     width: "100%",
                        //     display: "flex",
                        //     justifyContent: "space-between",
                        //     alignItems: "center",
                        //     padding: "8px 0",
                        //     borderBottom:
                        //       // i < 6 ? `1px solid ${T.cardBorder}` : "none",
                        //       `1px solid ${T.cardBorder}`,
                        //   }}
                        // >
                        //   <span style={{ fontSize: 12, color: T.textMuted }}>
                        //     {field?.meta_key
                        //       .replaceAll("_", " ")
                        //       .replace(/\b\w/g, (char) => char.toUpperCase())}
                        //   </span>

                        //   <span
                        //     style={{
                        //       fontSize: 13,
                        //       fontWeight: field.highlight ? 700 : 500,
                        //       color: field.highlight ? "#22c55e" : T.text,
                        //       fontFamily: field.mono ? "monospace" : "inherit",
                        //       fontSize: field.mono ? 11 : 13,
                        //     }}
                        //   >
                        //     {field?.meta_value || "-"}
                        //   </span>
                        // </div>
                        <NewMetaField
                          key={i}
                          label={field.meta_key
                            .replaceAll("_", " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                          value={field?.meta_value}
                        />
                      ))
                    : null}
                  {otherMeta?.length > 0 &&
                    otherMeta?.map((field, i) => {
                      return (
                        <>
                          <NewMetaField
                            key={i}
                            label={field.meta_key
                              .replaceAll("_", " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            value={field?.meta_value}
                          />
                        </>
                      );
                    })}
                </div>
              </Card>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

const TransactionTabs = ({ leadDetail }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {/* className="bg-white rounded-[12px] p-5  border border-[rgba(0,0,0,0.08)]  flex flex-col gap-[10px]" */}
      {leadDetail?.transactions?.length ? (
        <div className="space-y-3">
          {/* <div className="flex flex-col gap-y-[10px]">
            <div className="flex justify-between items-center">
              <p className="text-sm font-semibold leading-normal">
                Transactions
              </p>
            </div>
          </div> */}
          {/* {leadDetail?.transactions?.map((tx) => (
            <Field
              key={tx?.transactionid}
              label={tx?.transactiontime}
              value={`$${tx.amount}`}
              endTag={true}
              LastElement={() => (
                <StatusChip
                  color={
                    tx.transactionstatus == "success"
                      ? "green"
                      : tx.transactionstatus == "pending"
                        ? "blue"
                        : "red"
                  }
                >
                  {tx.transactionstatus}
                </StatusChip>
              )}
              icon={CheckCircle}
            />
          ))} */}
          {leadDetail?.transactions?.map((tx) => (
            <TransactionField key={tx.transactionid} tx={tx} />
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-sm italic text-center">
          No Transaction found.
        </p>
      )}
    </div>
  );
};
const TransactionTabsNew = ({ leadDetail }) => {
  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [invoiceProjectKey, setInvoiceProjectKey] = useState(null);
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {/* className="bg-white rounded-[12px] p-5  border border-[rgba(0,0,0,0.08)]  flex flex-col gap-[10px]" */}
        {leadDetail?.transactions?.length ? (
          <div className="space-y-3">
            <DynamicTable
              data={leadDetail?.transactions}
              rowKey="transactionid"
              onRowClick={(row) => {
                if (row?.projectkey) {
                  setInvoicePopup(true);
                  setInvoiceProjectKey(row?.projectkey);
                }
              }}
              columns={[
                {
                  key: "transactionkey",
                  label: "Transaction Key",
                  icon: Key, // icon for header
                  copy: true,
                  render: (row) => row.transactionkey ?? "-",
                },
                {
                  key: "amount",
                  label: "Amount",
                  icon: DollarSign, // icon for header
                  render: (row) => `$${row.amount ?? "-"}`, // prepend $ sign
                },
                {
                  key: "invoice_id",
                  label: "Invoice Id",
                  icon: Receipt, // icon for header
                  // render: (row) => `$${row.amount ?? "-"}`, // prepend $ sign
                },
                {
                  key: "transactiontype",
                  label: "Method",
                  icon: ClipboardType, // icon for header
                  // render: (row) => `$${row.amount ?? "-"}`, // prepend $ sign
                },
                {
                  key: "merchant",
                  label: "Merchant",
                  icon: UserRound, // icon for header
                  // render: (row) => `$${row.amount ?? "-"}`, // prepend $ sign
                },
                {
                  key: "transactionstatus",
                  label: "Status",
                  icon: ChartNoAxesCombined, // icon for header
                  render: (row) => {
                    const color =
                      row.transactionstatus === "success"
                        ? "green"
                        : row.transactionstatus === "pending"
                          ? "blue"
                          : "red";

                    return (
                      <div
                        className={`inline-flex items-center  gap-1 rounded-[6px]  px-[9px] py-[3px] text-xs font-medium ${
                          color === "green"
                            ? "bg-emerald-100 text-emerald-700"
                            : color === "blue"
                              ? "bg-blue-100 text-blue-700"
                              : "bg-rose-100 text-rose-700"
                        }`}
                      >
                        {row.transactionstatus ?? "-"}
                      </div>
                    );
                  },
                },
              ]}
            />
          </div>
        ) : (
          <p className="text-gray-400 text-sm italic text-center">
            No Transaction found.
          </p>
        )}
      </div>

      {invoicePopup && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceData(null);
            setInvoiceProjectKey(null);
          }}
          data={invoiceData}
          projectkey={invoiceProjectKey}
          type="project"
        />
      )}
    </>
  );
};

const CommentsTab = ({
  leadDetail,
  IsVerified,
  commentTypes,
  handleVerificationChange,
  condition = "",
  updateCount = () => {},
}) => {
  return (
    <>
      <div className="space-y-4 !h-full">
        <CommentsSection
          type="contact"
          id={leadDetail?.userid}
          apiBaseUrl="contact"
          title="true"
          commentTypes={commentTypes}
          IsVerified={IsVerified}
          handleVerificationChange={handleVerificationChange}
          condition={condition}
          updateCount={updateCount}
          data={leadDetail}
          HasPopupUi={false}
        />
      </div>
    </>
  );
};

// const TimelineTab = ({
//   leadDetail,
//   onError,
//   onSubmit,
//   UserList,
//   condition,
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   const [type, setType] = useState("");
//   return (
//     <div>
//       {leadDetail?.activities?.length ? (
//         <>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 0,
//               position: "relative",
//             }}
//           >
//             {/* Quick log bar */}

//             <Card
//               style={{
//                 padding: "12px 16px",
//                 marginBottom: 12,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//             >
//               <span
//                 style={{ fontSize: 12, color: T.textMuted, fontWeight: 500 }}
//               >
//                 Quick log:
//               </span>

//               {[
//                 "Call",
//                 "Meeting",
//                 "Email",
//                 "Follow-up",
//                 "Demo",
//                 "Chat",
//                 "Consultation",
//                 "Presentation",
//               ].map((type) => (
//                 <button
//                   key={type}
//                   onClick={() => {
//                     if (typeof setSelectedActivity === "function") {
//                       setSelectedActivity(null);
//                       setType(type);
//                       console.log("type", type);
//                     }
//                     if (typeof setShowActivityModal === "function") {
//                       setShowActivityModal(true);
//                       setType(type);
//                     }
//                   }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "5px 12px",
//                     borderRadius: 20,
//                     border: `1px solid ${activityColors[type?.toLocaleLowerCase() || "default"]}25`,
//                     background:
//                       activityColors[type?.toLocaleLowerCase()] + "08",
//                     color: activityColors[type?.toLocaleLowerCase()],
//                     cursor: "pointer",
//                     fontSize: 11,
//                     fontWeight: 600,
//                     fontFamily: "inherit",
//                   }}
//                 >
//                   <Icon
//                     name={activityIcons[type?.toLocaleLowerCase() || "default"]}
//                     size={12}
//                     color={
//                       activityColors[type?.toLocaleLowerCase() || "default"]
//                     }
//                   />
//                   {type.charAt(0).toUpperCase() + type.slice(1)}
//                 </button>
//               ))}
//             </Card>

//             {/* Timeline items */}
//             <div style={{ position: "relative", paddingLeft: 28 }}>
//               {/* Vertical line */}
//               <div
//                 style={{
//                   position: "absolute",
//                   left: 11,
//                   // top: 8,
//                   // bottom: 8,
//                   top: 15,
//                   bottom: 40,
//                   width: 2,
//                   background: "#ddd8d2",
//                   borderRadius: 1,
//                 }}
//               />

//               {leadDetail?.activities?.map((a, i) => {
//                 const color =
//                   activityColors[a?.icon?.toLocaleLowerCase()] ||
//                   "#8b5cf6" ||
//                   "#6b7280";
//                 // const expanded = expandedActivity === a.id;
//                 return (
//                   <div
//                     key={a.id}
//                     style={{ position: "relative", marginBottom: 8 }}
//                   >
//                     {/* Dot */}
//                     <div
//                       style={{
//                         position: "absolute",
//                         left: -22,
//                         top: 16,
//                         width: 12,
//                         height: 12,
//                         borderRadius: "50%",
//                         background: color + "20",
//                         border: `2.5px solid ${color}`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         zIndex: 1,
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: 4,
//                           height: 4,
//                           borderRadius: "50%",
//                           background: color,
//                         }}
//                       />
//                     </div>

//                     <Card
//                       hover
//                       // onClick={() =>
//                       //   setExpandedActivity(expanded ? null : a.id)
//                       // }
//                       style={{ padding: "14px 18px" }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "flex-start",
//                           gap: 12,
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: 32,
//                             height: 32,
//                             borderRadius: 8,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: color + "12",
//                             flexShrink: 0,
//                           }}
//                         >
//                           <Icon
//                             name={
//                               activityIcons[
//                                 a?.icon?.toLocaleLowerCase() || "default"
//                               ]
//                             }
//                             size={14}
//                             color={color}
//                           />
//                           {/* <div
//                             style={{
//                               width: 32,
//                               height: 32,
//                               borderRadius: 14,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               background: `linear-gradient(135deg, ${T.accent}, #8b5cf6)`,
//                               color: "#fff",
//                               fontSize: 18,
//                               fontWeight: 700,
//                               flexShrink: 0,
//                             }}
//                           >
//                             {getInitials(a.user.name) || "U"}
//                           </div> */}
//                         </div>
//                         <div style={{ flex: 1, minWidth: 0 }}>
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               gap: 8,
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontSize: 13,
//                                 fontWeight: 600,
//                                 color: T.text,
//                               }}
//                             >
//                               {a.log}
//                             </span>
//                             {/* <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
//                                   {a?.outcome && <Badge color={color}>{a.outcome}</Badge>}
//                                   {a?.hasRecording && (
//                                     <div style={{
//                                       display: 'flex', alignItems: 'center', gap: 4, padding: '3px 8px',
//                                       borderRadius: 6, background: '#ef444412', cursor: 'pointer',
//                                     }}>
//                                       <Icon name="play" size={10} color="#ef4444" />
//                                       <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 600 }}>REC</span>
//                                     </div>
//                                   )}
//                                 </div> */}
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               gap: 12,
//                               marginTop: 5,
//                               fontSize: 11,
//                               color: T.textMuted,
//                             }}
//                           >
//                             <span>{a?.logtime}</span>
//                             <span>by {a.user.name}</span>
//                             {/* {a.duration && <span>{a.duration}</span>} */}
//                           </div>
//                         </div>
//                       </div>
//                     </Card>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </>
//       ) : (
//         // <div className="space-y-4">
//         //   <div className="flex flex-col gap-y-[17px]">
//         //     <div className="bg-white   p-5 rounded-[10px] border border-[#E1E4EA] flex flex-col gap-[10px]">

//         //       <div className="flex flex-col gap-y-[10px]">
//         //         <div className="flex justify-between items-center">
//         //           <p className="text-xl font-medium leading-normal">Timeline</p>
//         //         </div>
//         //       </div>

//         //       <div className="flex flex-col h-full mt-2">
//         //         <div className="flex-1 overflow-y-auto pr-4">
//         //           <div className="relative ml-2 mt-2">
//         //             {leadDetail?.activities?.length ? (
//         //               <div className="absolute left-3 top-0 h-full border-l-2 border-gray-200"></div>
//         //             ) : null}

//         //             {leadDetail.activities.map((act, i) => {
//         //               const userName = act?.user?.name || "U";
//         //               const userInitial = userName.charAt(0).toUpperCase();
//         //               const colors = [
//         //                 "bg-emerald-500",
//         //                 "bg-blue-500",
//         //                 "bg-indigo-500",
//         //                 "bg-rose-500",
//         //               ];
//         //               const userColor = "bg-slate-200";

//         //               return (
//         //                 <div key={i} className="relative pl-10 pb-6">
//         //                   {/* ✅ User Initial Circle */}
//         //                   <div
//         //                     className={`absolute left-0 top-0 flex items-center justify-center w-7 h-7 rounded-full bg-slate-200 text-slate-700 text-xs font-semibold`}
//         //                   >
//         //                     {userInitial}
//         //                   </div>

//         //                   {/* ✅ Activity content properly aligned */}
//         //                   <div className="flex flex-col gap-1 pt-0.5">
//         //                     <div className="flex justify-between items-center">
//         //                       <p className="text-sm font-medium text-gray-800">
//         //                         {act.log}
//         //                       </p>
//         //                       <p className="text-xs text-gray-400">
//         //                         {/* {moment(act.logtime).fromNow()} */}
//         //                         {act.logtime}
//         //                       </p>
//         //                     </div>

//         //                     {act?.user?.name && (
//         //                       <div className="flex items-center gap-1 text-xs text-gray-500">
//         //                         <User className="h-3 w-3 text-gray-400" />
//         //                         <span className="leading-none">
//         //                           by {act.user.name}
//         //                         </span>
//         //                       </div>
//         //                     )}
//         //                   </div>
//         //                 </div>
//         //               );
//         //             })}
//         //           </div>
//         //         </div>
//         //       </div>
//         //     </div>
//         //   </div>
//         // </div>
//         <p className="text-gray-400 text-sm italic text-center">
//           No timeline available.
//         </p>
//       )}

//       {showActivityModal && (
//         <FollowUpPopup
//           onClose={() => {
//             setShowActivityModal(false);
//             setSelectedActivity({});
//           }}
//           CustomerData={{
//             entity_type: condition == "account" ? "contact" : condition,
//             entity_name: leadDetail.name,
//             entity_id: leadDetail?.userid,
//           }}
//           tabIndex={2}
//           onError={onError}
//           onSubmit={onSubmit}
//           id={leadDetail?.userid}
//           entitytype="contact"
//           entityname={leadDetail?.name}
//           UsersList={UserList}
//           type={type.toLowerCase()}
//         />
//       )}
//     </div>
//   );
// };

// const FollowUpsTab = ({ leadDetail, onError, onSubmit, UserList }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   return (
//     <>
//       <div className="flex flex-col gap-[10px] w-full h-full overflow-auto">

//         <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//           <Card
//             style={{
//               padding: "12px 16px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <span style={{ fontSize: 13, fontWeight: 600 }}>
//               Scheduled Follow-Ups
//             </span>
//             <ActionButton
//               icon="plus"
//               label="New Follow-Up"
//               variant="filled"
//               style={{ width: "auto", padding: "7px 14px", fontSize: 12 }}
//               onClick={() => {
//                 if (typeof setSelectedActivity === "function") {
//                   setSelectedActivity(null);
//                 }
//                 if (typeof setShowActivityModal === "function") {
//                   setShowActivityModal(true);
//                 }
//               }}
//             />
//           </Card>
//           {leadDetail?.schedules?.length ? (
//             leadDetail?.schedules?.map((f) => (
//               <Card
//                 key={f.id}
//                 hover
//                 style={{ padding: "14px 18px" }}
//                 onClick={() => {
//                   setSelectedActivity(f);
//                   setShowActivityModal(true);
//                 }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       background:
//                         f.status?.toLowerCase() === "completed"
//                           ? "#22c55e"
//                           : priorityColors[f.priority],
//                       boxShadow:
//                         f.status?.toLowerCase() === "completed"
//                           ? "none"
//                           : `0 0 0 3px ${priorityColors[f.priority]}20`,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 600,
//                         color: T.text,
//                         textDecoration:
//                           f.status.toLowerCase() === "completed"
//                             ? "line-through"
//                             : "none",
//                         opacity: f.status === "completed" ? 0.6 : 1,
//                       }}
//                     >
//                       {f?.note}
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: 12,
//                         marginTop: 4,
//                         fontSize: 11,
//                         color: T.textMuted,
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="calendar" size={11} color={T.textMuted} />{" "}
//                         {f?.due_date}
//                       </span>
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="clock" size={11} color={T.textMuted} />{" "}
//                         {f?.due_time}
//                       </span>
//                     </div>
//                   </div>
//                   <Badge color={priorityColors[f.priority]}>{f.priority}</Badge>
//                 </div>
//               </Card>
//             ))
//           ) : (
//             <p className="text-gray-400 text-sm italic text-center">
//               No scheduled activities.
//             </p>
//           )}
//         </div>

//         {/* ✅ Modal Integration */}
//         {showActivityModal && (
//           <FollowUpPopup
//             onClose={() => {
//               setShowActivityModal(false);
//               setSelectedActivity({});
//             }}
//             CustomerData={selectedActivity}
//             tabIndex={2}
//             onError={onError}
//             onSubmit={onSubmit}
//             id={leadDetail?.userid}
//             entitytype="contact"
//             entityname={leadDetail?.name}
//             UsersList={UserList}
//           />
//         )}
//       </div>
//     </>
//   );
// };

export default function DetailPageMain({ defaultDealId = null }) {
  const { state } = useLocation();

  // const dealIdFromLink = state?.defaultDealId ?? defaultDealId ;

  const {
    id,
    condition,
    dealid,
    condition2 = "",
    followUpID = "",
  } = useParams();

  const dealIdFromLink = dealid ?? null;
  const [leadDetail, setLeadDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [UsersList, setUsersList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [entityData, setEntityData] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [menuOpen, setMenuOpen] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(true);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(true);
  const [dealCardOpen, setDealCardOpen] = useState(false);
  const [projectCardOpen, setProjectCardOpen] = useState(false);
  const [clientDeals, setClientDeals] = useState([]);
  const [clientProjects, setClientProjects] = useState([]);

  const [activeDealId, setActiveDealId] = useState(null);
  const [activeProjectKey, setActiveProjectKey] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [productionUsers, setProductionUsers] = useState([]);
  const [commentTypes, setCommentTypes] = useState({});
  const [statusList, setStatusList] = useState([]);

  const apiCall = useApiCall();

  const getData = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `accounts/get-account/${id}`,
      });
      setLeadDetail(res?.data);
      setClientDeals(res?.data?.client_deals);
      setClientProjects(res?.data?.client_projects);

      console.log("res?.data", res?.data);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getCommentTypes = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });
      console.log("res?.data", res?.data);
      setCommentTypes(res?.data?.comment_types || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const handleVerificationChange = (status) => {
    setLeadDetail((prev) => ({
      ...prev,
      verified: status,
    }));
  };

  useEffect(() => {
    DealStage();
    fetchUsers();
    if (condition == "contact") {
      getCommentTypes();
    }
    // if (MainIndex == 2) {
    getStatus();
    // }
  }, []);

  const getStatus = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });

      console.log(res?.data);
      setStatusList(res?.data?.project_status || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsersList(newUsers);
      setProductionUsers(res?.agents || []);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const [currentData, setCurrentData] = useState({});
  const [DealStages, setDealStages] = useState([]);
  const [showAddDealModal, setShowAddDealModal] = useState(false);
  const [showLead, setShowLead] = useState(false);
  const [Menu, showMenu] = useState(false);
  const [dealDataLoading, setdealDataLoading] = useState(false);
  const [activeDealData, setActiveDealData] = useState({});
  const [activeProjectData, setActiveProjectData] = useState({});
  const [projectDataLoading, setProjectDataLoading] = useState(false);
  const [leftTabIndex, setLeftTabIndex] = useState(0);
  const [MainIndex, setMainIndex] = useState(0);

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowLead(false);
    setShowAddDealModal(false);
    setShowActivityModal(false);
    setCurrentData({});
    setMainIndex(0);
    getData();
  };

  const onFollowUpSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowActivityModal(false);

    {
      if (MainIndex == "0") {
        getData();
      } else if (MainIndex == "1") {
        getActiveDeal(activeDealData?.dealid);
      } else if (MainIndex == "2") {
        getActiveProject(
          activeProjectData?.projectkey || activeProjectData?.project_key,
        );
      } else {
      }
    }
  };

  const updateDealSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowWonModal(false);
    setShowLostModal(false);
    getData();
    getActiveDeal(activeDealData?.dealid);
  };

  const dealSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowAddDealModal(false);
  };

  const updateData = (val, val2) => {
    setActiveDealData(val);
    setClientDeals(val2);
  };

  const updateProjectData = (val, val2) => {
    setActiveProjectData(val);
    setClientProjects(val2);
  };

  const updateCount = (updateData) => {
    if (MainIndex == "0") {
      setLeadDetail(updateData);
    } else if (MainIndex == "1") {
      setActiveDealData(updateData);
    } else if (MainIndex == "2") {
      setActiveProjectData(updateData);
    }
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editLead = (ele) => {
    setCurrentData(ele);
    setShowLead(true);
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost",
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  // const getPackages = async (subProductId) => {
  //   if (!subProductId) return;
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `products/get-sub-product-packages/${subProductId}`,
  //     });
  //     setPackages(res?.data || []);
  //   } catch (error) {
  //     console.error("Error fetching packages:", error);
  //   }
  // };

  // const getSubProducts = async (productId) => {
  //   if (!productId) return;
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `products/get-sub-products/${productId}`,
  //     });
  //     setSubProducts(res?.data || []);
  //   } catch (error) {
  //     console.error("Error fetching sub products:", error);
  //   }
  // };

  const getActiveProject = async (key) => {
    try {
      setProjectDataLoading(true);
      const res = await apiCall({
        method: "get",
        url: `projects/get-project/${key}`,
      });

      setActiveProjectData(res?.project || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    } finally {
      setProjectDataLoading(false);
    }
  };

  const [DealStatus, setDealStatus] = useState("");
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);

  const getActiveDeal = async (id) => {
    try {
      setdealDataLoading(true);
      const res = await apiCall({
        method: "get",
        url: `deals/get-deal/${id}`,
      });

      setActiveDealData(res?.data || []);
      setDealStatus(res?.data?.current_stage?.dealstatus || "");
    } catch (error) {
      console.warn("Error fetching brands:", error);
    } finally {
      setdealDataLoading(false);
    }
  };

  const TabButton = ({ active, label, count, onClick }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          padding: "8px 16px",
          borderRadius: 8,
          border: "none",
          background: active
            ? T.accent
            : hovered
              ? "rgba(0,0,0,0.04)"
              : "transparent",
          color: active ? "#fff" : hovered ? T.text : T.textSecondary,
          cursor: "pointer",
          fontSize: 13,
          fontWeight: active ? 600 : 500,
          fontFamily: "inherit",
          transition: "all 0.15s",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {label}
        {count != undefined && (
          <span
            style={{
              background: active
                ? "rgba(255,255,255,0.25)"
                : "rgba(0,0,0,0.06)",
              padding: "1px 7px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 600,
              color: active ? "#fff" : T.textMuted,
            }}
          >
            {count}
          </span>
        )}
      </button>
    );
  };

  // ─── STAGE PROGRESS ───
  const StageProgress = ({
    stages = [],
    activeDealData = {},
    lastStage = "",
    stageChange = () => {},
  }) => {
    const [hoveredStage, setHoveredStage] = useState(null);
    const isWon = activeDealData?.current_stage?.dealstatus === "Won";
    const isLost = activeDealData?.current_stage?.dealstatus === "Lost";

    const currentStageIndex =
      isWon || isLost
        ? DealStages.findIndex((s) => s.name === lastStage?.dealstatus)
        : DealStages.findIndex(
            (s) => s.name === activeDealData?.current_stage?.dealstatus,
          );

    const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
    const isWonOrLost = isWon || isLost;

    const formatStageKey = (stage) => {
      return stage?.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
    };

    const handleStageChange = async (newStage) => {
      const lowerStage = formatStageKey(newStage); // lowercase + underscores
      const currentStage = activeDealData?.current_stage?.dealstatus ?? "-"; // ✅ added

      // if (lowerStage === "won") {
      //   setWonFormDeal(activeDealData);
      //   setShowWonModal(true);
      //   return;
      // }

      // if (lowerStage === "lost") {
      //   setLostFormDeal({
      //     dealkey: activeDealData.dealkey,
      //     name: activeDealData.name,
      //   });
      //   setShowLostModal(true);
      //   return;
      // }

      const resultSwal = await Swal.fire({
        title: `${activeDealData.name}`,
        text: `Move from "${currentStage}" to "${newStage}"?`, // ✅ fixed reference
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      });

      if (resultSwal.isConfirmed) {
        try {
          await apiCall({
            method: "post",
            url: "deals/update-deal-status",
            data: { dealkey: activeDealData.dealkey, dealstatus: lowerStage },
          });

          // **Update card immediately without reload**
          // onStatusChange(activeDealData.dealid, newStage); // ✅ keep `newStage` or `lowerStage` depending on your display logic

          const NewClientDeals = clientDeals.map((d) =>
            d.dealid === activeDealData.dealid
              ? {
                  ...d,
                  current_stage: {
                    ...d.current_stage,
                    dealstatus: newStage,
                  },
                } // new object
              : d,
          );

          updateData(
            {
              ...activeDealData,
              current_stage: {
                ...activeDealData.current_stage,
                dealstatus: newStage,
              },
            },
            NewClientDeals,
          );
          stageChange();

          Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
        } catch (err) {
          Swal.fire(
            "Error",
            err?.response?.data?.message || "Something went wrong",
            "error",
          );
        }
      }
    };

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 0, width: "100%" }}
      >
        {stages?.map((stage, i) => {
          const isCompleted = isWonOrLost
            ? i <= currentStageIndex
            : i <= currentStageIndex;
          const isConneted = i < currentStageIndex;
          const isCurrent = i === currentStageIndex;
          const isHovered = hoveredStage === i;
          const color = isWonOrLost
            ? "#767779"
            : STATUS_COLORS[stage] || T.accent;
          return (
            <div
              key={stage}
              style={{ flex: 1, display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                  flex: 1,
                  cursor: isWonOrLost || isCurrent ? "not-allowed" : "pointer",
                  position: "relative",
                }}
                onMouseEnter={() => setHoveredStage(i)}
                onMouseLeave={() => setHoveredStage(null)}
                // onClick={() => onStageClick(i)}
                onClick={() =>
                  !isWonOrLost && !isCurrent && handleStageChange(stage)
                }
              >
                {/* Node */}
                <div
                  style={{
                    width: isCurrent ? 36 : 28,
                    height: isCurrent ? 36 : 28,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: isCompleted
                      ? color
                      : isCurrent
                        ? color
                        : isHovered
                          ? color + "20"
                          : "#e8e5e0",
                    border: isCurrent ? `3px solid ${color}40` : "none",
                    boxShadow: isCurrent
                      ? `0 0 0 4px ${color}15, 0 2px 8px ${color}30`
                      : isHovered
                        ? `0 0 0 3px ${color}15`
                        : "none",
                    transition: "all 0.2s",
                    transform: isHovered && !isCurrent ? "scale(1.15)" : "none",
                  }}
                >
                  {isCompleted ? (
                    <Icon name="check" size={14} color="#fff" />
                  ) : isCurrent ? (
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: "#fff",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: isHovered ? color : "#c4c0bb",
                      }}
                    />
                  )}
                </div>
                {/* Label */}
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: isCurrent ? 700 : isCompleted ? 600 : 500,
                    color: isCurrent
                      ? color
                      : isCompleted
                        ? T.text
                        : T.textMuted,
                    textAlign: "center",
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  {stage}
                </span>
                {/* Click hint */}
                {isHovered && !isCurrent && (
                  <span
                    style={{
                      position: "absolute",
                      top: -28,
                      background: T.text,
                      color: "#fff",
                      padding: "3px 8px",
                      borderRadius: 6,
                      fontSize: 10,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Click to move here
                  </span>
                )}
              </div>
              {/* Connector */}
              {i < stages.length - 1 && (
                <div
                  style={{
                    height: 3,
                    flex: 1,
                    borderRadius: 2,
                    marginTop: -20,
                    background: isConneted ? color : "#e0ddd8",
                    transition: "all 0.3s",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // Status Progress
  const StatusProgress = ({
    statusList = [],
    activeProjectData = {},
    statusChange = () => {},
  }) => {
    const [hoveredStage, setHoveredStage] = useState(null);

    const currentStatusIndex = statusList?.findIndex(
      (s) => s.id === activeProjectData?.status,
    );

    const formatStageKey = (status) => {
      return status?.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
    };

    const handleStatusChange = async (status) => {
      const formattedStatus = status.value
        ? status.value
            .split("_")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
            )
            .join(" ")
        : "-";
      // const lowerStage = formatStageKey(status.value); // lowercase + underscores
      const currentStage =
        activeProjectData?.status
          ?.split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ") ?? "-"; // ✅ added

      const resultSwal = await Swal.fire({
        title: `${activeProjectData?.invoiceid}`,
        text: `Move from "${currentStage}" to "${formattedStatus}"?`, // ✅ fixed reference
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      });

      if (resultSwal.isConfirmed) {
        try {
          let apiRes = await apiCall({
            method: "post",
            url: "project/update-project-status",
            data: {
              project_key: activeProjectData.projectkey,
              status: status?.id,
            },
          });

          statusChange();

          const updatedCLientProject = clientProjects?.map((eachList) =>
            eachList.projectid == activeProjectData.projectid
              ? {
                  ...eachList,
                  status: status.id,
                } // new object
              : eachList,
          );

          updateProjectData(
            {
              ...activeProjectData,
              status: status.id,
            },
            updatedCLientProject,
          );
          return apiRes;
        } catch (error) {
          console.log(error);
          onError(
            error?.response.data?.respMsg ||
              error?.response.data?.responseMessage ||
              error?.response.data?.message ||
              "Some Thing Went Wrong",
          );
          throw error;
        }
      }
    };

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 0, width: "100%" }}
      >
        {statusList?.map((status, i) => {
          const isCompleted = i <= currentStatusIndex;
          const isConneted = i < currentStatusIndex;
          const isCurrent = i === currentStatusIndex;
          const isHovered = hoveredStage === i;
          const color = ProjectStatusHEX[status?.id] || T.accent;
          return (
            <div
              key={status?.id}
              style={{ flex: 1, display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                  flex: 1,
                  cursor: "pointer",
                  position: "relative",
                }}
                onMouseEnter={() => setHoveredStage(i)}
                onMouseLeave={() => setHoveredStage(null)}
                // onClick={() => onStageClick(i)}
                onClick={() => !isCurrent && handleStatusChange(status)}
              >
                {/* Node */}
                <div
                  style={{
                    width: isCurrent ? 36 : 28,
                    height: isCurrent ? 36 : 28,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: isCompleted
                      ? color
                      : isCurrent
                        ? color
                        : isHovered
                          ? color + "20"
                          : "#e8e5e0",
                    border: isCurrent ? `3px solid ${color}40` : "none",
                    boxShadow: isCurrent
                      ? `0 0 0 4px ${color}15, 0 2px 8px ${color}30`
                      : isHovered
                        ? `0 0 0 3px ${color}15`
                        : "none",
                    transition: "all 0.2s",
                    transform: isHovered && !isCurrent ? "scale(1.15)" : "none",
                  }}
                >
                  {isCompleted ? (
                    <Icon name="check" size={14} color="#fff" />
                  ) : isCurrent ? (
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: "#fff",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: isHovered ? color : "#c4c0bb",
                      }}
                    />
                  )}
                </div>
                {/* Label */}
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: isCurrent ? 700 : isCompleted ? 600 : 500,
                    color: isCurrent
                      ? color
                      : isCompleted
                        ? T.text
                        : T.textMuted,
                    textAlign: "center",
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  {status?.value}
                </span>
                {/* Click hint */}
                {isHovered && !isCurrent && (
                  <span
                    style={{
                      position: "absolute",
                      top: -28,
                      background: T.text,
                      color: "#fff",
                      padding: "3px 8px",
                      borderRadius: 6,
                      fontSize: 10,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Click to move here
                  </span>
                )}
              </div>
              {/* Connector */}
              {i < statusList?.length - 1 && (
                <div
                  style={{
                    height: 3,
                    flex: 1,
                    borderRadius: 2,
                    marginTop: -20,
                    background: isConneted ? color : "#e0ddd8",
                    transition: "all 0.3s",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const dealRefs = useRef({});

  useEffect(() => {
    if (activeDealData?.dealid && dealRefs.current[activeDealData.dealid]) {
      dealRefs.current[activeDealData.dealid].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [activeDealData, leadDetail]);

  const projectRefs = useRef({});

  useEffect(() => {
    if (
      activeProjectData?.projectid &&
      projectRefs.current[activeProjectData.projectid]
    ) {
      projectRefs.current[activeProjectData.projectid].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeProjectData, leadDetail]);

  const TAB_CONFIG = [
    {
      key: "timeline",
      label: "Timeline",
      component: (
        <TimelineTab
          leadDetail={leadDetail}
          onSubmit={onSuccess}
          onError={onError}
          UsersList={UsersList}
          condition={condition}
          MainIndex="0"
        />
      ),
      count: leadDetail?.activities_count,
    },
    {
      key: "details",
      label: "Details",
      component: <Details leadDetail={leadDetail} />,
    },
    {
      key: "transactions",
      label: "Transactions",
      component: <TransactionTabs leadDetail={leadDetail} />,
      count: leadDetail?.transactions_count,
    },
    {
      key: "followups",
      label: "Follow ups",
      component: (
        <FollowUpsTab
          leadDetail={leadDetail}
          onSubmit={onFollowUpSuccess}
          onError={onError}
          UsersList={UsersList}
          id={leadDetail?.userid}
          entitytype="contact"
          entityname={leadDetail?.name}
          followUpID={followUpID ?? ""}
        />
      ),
      count: leadDetail?.schedules_count,
    },

    {
      key: "comments",
      label: "Comments",
      component: (
        <CommentsTab
          leadDetail={leadDetail}
          IsVerified={leadDetail?.verified}
          commentTypes={commentTypes}
          handleVerificationChange={handleVerificationChange}
          condition={condition}
          updateCount={updateCount}
        />
      ),
      count: leadDetail?.comments_count,
    },
    {
      key: "files",
      label: "Files",
      component: (
        <FilesTab
          leadId={leadDetail?.userid}
          attachments={leadDetail?.attachments}
          attachmenttype="contact"
          updateCount={updateCount}
          data={leadDetail}
        />
      ),
      count: leadDetail?.attachments_count,
    },
  ].filter(Boolean);

  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (condition2) {
      setTab(3);
    }
  }, []);

  const [tabsCustomizeTabs, setTabsCustomizeTabs] = useState({
    details: true,
    transactions: true,
    followups: true,
    timeline: true,
    comments: true,
    followups: true,
    files: true,
  });

  const handleTabChange = (index) => {
    setTab(index);
  };

  const renderedTabs = useMemo(() => {
    return TAB_CONFIG?.map((tabItem, index) => {
      // if (!tabsCustomizeTabs[tabItem.key]) return null;
      if (tabItem.key !== "timeline" && !tabsCustomizeTabs[tabItem.key])
        return null;
      return (
        <TabButton
          key={tabItem.key}
          active={tab === index}
          label={tabItem.label}
          count={tabItem.count}
          onClick={() => {
            if (tabItem?.component) {
              handleTabChange(index);
              setDealCardOpen(false);
              setProjectCardOpen(false);
            }
            if (tabItem?.key == "timeline") {
              getData();
            }
          }}
        />
        // <li
        //   key={tabItem.key}
        //   className={`${tab === index ? Style.active : null}`}
        // onClick={() => {
        //   if (tabItem?.component) {
        //     handleTabChange(index);
        //     setDealCardOpen(false);
        //     setProjectCardOpen(false);
        //   }
        // }}
        // >
        //   <div className={Style.icon}></div>
        //   <span>{tabItem.label}</span>
        // </li>
      );
    });
  }, [tab, tabsCustomizeTabs, leadDetail]);

  const dealDetail = (dealid) => {
    if (MainIndex === 1 && activeDealId === dealid) {
      // Already viewing this deal → go back
      setMainIndex(0);
      setDealCardOpen(false);
      return;
    }

    // Otherwise open new deal detail
    setActiveDealId(dealid);
    getActiveDeal(dealid);
    setMainIndex(1);
    setProjectCardOpen(false);
    setDealCardOpen(true);
  };

  useEffect(() => {
    if (dealIdFromLink && condition == "deal") {
      dealDetail(dealIdFromLink);
    }
    if (dealIdFromLink && condition == "project") {
      projectDetail(dealIdFromLink);
    }
  }, [dealIdFromLink]);

  const projectDetail = (projectKey) => {
    if (MainIndex === 2 && activeProjectKey === projectKey) {
      // Already viewing this project → go back
      setMainIndex(0);
      setProjectCardOpen(false);
      return;
    }

    // Otherwise open new project detail
    setActiveProjectKey(projectKey);
    getActiveProject(projectKey);
    setMainIndex(2);
    setProjectCardOpen(true);
    setDealCardOpen(false);
    setLeftTabIndex(1);
  };

  const [showAll, setShowAll] = useState(false);

  const users = Array.isArray(leadDetail?.assigned_users)
    ? leadDetail?.assigned_users
    : [];

  const visibleUsers = showAll ? users : users.slice(0, 2);
  const hiddenCount = users.length - 3;

  const remainingUsers = useMemo(() => {
    if (productionUsers?.length == 0) return [];

    const assignedUserIds = new Set(users?.map((u) => u?.userid));

    return productionUsers?.filter(
      (user) => !assignedUserIds.has(user?.userid),
    );
  }, [users, productionUsers]);

  const filteredUsers = useMemo(() => {
    if (!search.trim()) return remainingUsers;

    return remainingUsers.filter((u) =>
      u.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, remainingUsers]);

  const addAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to assigned this agent?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      console.log("User cancelled");
      return;
    }

    let data = {
      client_id: leadDetail?.userid,
      agent_id: user?.userid,
    };

    try {
      const url = `users/assign-agent-to-client`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "Assigned Agent Successfully",
        timer: 1500,
      });

      setShowDropdown(false);
      getData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      setShowDropdown(false);
    }
  };

  const deleteAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this agent into assigned?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      console.log("User cancelled");
      return;
    }

    let data = {
      client_id: leadDetail?.userid,
      agent_id: user?.userid,
      type: "contact",
    };

    try {
      const url = `users/un-assign-agent-to-client`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "UnAssigned Agent Successfully",
        timer: 1500,
      });

      setShowDropdown(false);
      setShowAll(false);
      getData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      setShowDropdown(false);
    }
  };

  const menuRef = useRef(null);

  useClickOutside(menuRef, () => {
    showMenu(false);
  });

  const assignedRef = useRef(null);

  useClickOutside(assignedRef, () => {
    setShowAll(false);
  });

  const assignedDropdownRef = useRef(null);

  useClickOutside(assignedDropdownRef, () => {
    setShowDropdown(false);
  });

  // const handleSuccess = (message) => {
  //   if (onSuccess) onSuccess(message); // ✅ call parent prop
  // };

  //////////////////////

  const [activeTab, setActiveTab] = useState("timeline");
  const [currentStageIndex, setCurrentStageIndex] = useState("");
  const [activeDeal, setActiveDeal] = useState(0);
  const [showLogModal, setShowLogModal] = useState(false);
  const [logType, setLogType] = useState("call");
  const [expandedActivity, setExpandedActivity] = useState(null);

  ///////////////////////

  return (
    <>
      {isLoading ? (
        <InnerLoader />
      ) : !leadDetail ? (
        <div className="flex justify-center items-center w-full h-full">
          <DataNotFound title={"Details"} />
        </div>
      ) : (
        <div
          // className="mt-[20px] relative !overflow-hidden"
          // scrollClassName={"!overflow-hidden"}
          style={{
            display: "flex",
            height: "100vh",
            // fontFamily:
            //   "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
            background: T.bg,
            color: T.text,
            overflow: "hidden",
          }}
          className="innerPage"
        >
          <div
            // className="flex w-full h-full overflow-auto gap-2"
            style={{
              flex: 1,
              overflow: "auto",
              padding: "20px 0px 0px 0px",
              display: "flex",
              gap: 20,
            }}
          >
            {/* left side Section */}
            {/* <div
              className={`
                transition-all duration-300 ease-in-out shrink-0 
               
                ${leftSidebarOpen ? "w-[220px]" : "w-0 !p-0 overflow-hidden"}
              `}
            >
              <div className="flex flex-col gap-4 overflow-hidden overflow-y-auto h-full">
                {condition !== "contact" ? (
                  <div className="rounded-[10px] bg-white border border-[#E1E4EA] py-[8px] px-[8px] flex-shrink-0">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-[10px]">
                        {[{ label: "Deals" }, { label: "Projects" }].map(
                          (item, idx) => {
                            const activeleftBar = idx === leftTabIndex; // first tab active

                            return (
                              <button
                                key={idx}
                                className={`px-[25px] py-[7px] flex items-center gap-1 text-[14px] text-[#414651] font-medium rounded-[7px] transition-all
                                  ${activeleftBar
                                    ? "bg-[#2563eb] text-[#fff] font-[500]"
                                    : "text-[#8a8078]"
                                  }    
                                                            `}
                                onClick={() => {
                                  setLeftTabIndex(idx);
                                }}
                              >
                                <span>{item.label}</span>
                              </button>
                            );
                          },
                        )}
                      </div>

                     
                    </div>
                  </div>
                ) : null}

                {leftTabIndex == 0 ? (
                  <>
                    <div className="gap-y-[10px] h-full rounded-[10px] overflow-hidden">
                      

                      <div className="flex flex-col gap-y-[10px] max-h-[85%] min-h-0  overflow-auto">
                        {clientDeals?.map((eachList, i) => {
                          return (
                            <div
                              className={`p-[14px] rounded-[10px] cursor-pointer border bg-white transition-all duration-200 hover:bg-[#f1f1f1]  ${activeDealData.dealid == eachList.dealid &&
                                dealCardOpen
                                ? "border-[#2563eb] shadow-[0_0_0_3px_rgb(239,244,255)]"
                                : "border-[#e2ddd8]"
                                }`}
                              onClick={() => {
                                dealDetail(eachList?.dealid);
                              }}
                            >
                              <div className="cursor-pointer">
                                <div className="flex gap-x-1">
                                  <div className="flex flex-col">
                                    <div className="text-[14px] leading-5 font-medium">
                                      {eachList?.name}
                                    </div>
                                    <div className="text-[12px] mt-1 text-[#8a8078] capitalize">
                                      {eachList?.deal_package_name}
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-4">
                                  {eachList?.current_stage?.dealstatus ==
                                    "Need Analysis" ? (
                                    <Chip
                                      color={"yellow"}
                                      className="text-nowrap !text-[11px] cursor-pointer"
                                    >
                                      Need Analysis
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Value Proposition" ? (
                                    <Chip
                                      color="blue"
                                      className="text-nowrap !text-[11px] cursor-pointer"
                                    >
                                      Value Proposition
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Identify Decision" ? (
                                    <Chip
                                      color="violet"
                                      className="text-nowrap !text-[11px] cursor-pointer"
                                    >
                                      Identify Decision
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Proposal" ? (
                                    <Chip
                                      color="teal"
                                      className="!text-[11px] cursor-pointer"
                                    >
                                      Proposal
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Review" ? (
                                    <Chip
                                      color="indigo"
                                      className="!text-[11px] cursor-pointer"
                                    >
                                      Review
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Won" ? (
                                    <Chip
                                      color="green"
                                      className="!text-[11px] cursor-pointer"
                                    >
                                      Won
                                    </Chip>
                                  ) : eachList?.current_stage?.dealstatus ==
                                    "Lost" ? (
                                    <Chip
                                      color="red"
                                      className="!text-[11px] cursor-pointer"
                                    >
                                      Lost
                                    </Chip>
                                  ) : (
                                    <Chip
                                      color="gray"
                                      className="!text-[11px] cursor-pointer"
                                    >
                                      {eachList?.current_stage?.dealstatus ||
                                        "--"}
                                    </Chip>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : leftTabIndex == 1 ? (
                  <>
                    <div className="gap-y-[10px] h-full rounded-[10px] overflow-hidden">
                      
                      <div className="flex flex-col gap-y-[10px] max-h-[85%] min-h-0  overflow-auto">
                        {clientProjects?.length > 0 ? (
                          clientProjects?.map((eachList, i) => {
                            return (
                              <div
                                className={`p-[14px] rounded-[10px] cursor-pointer border bg-white transition-all duration-200 hover:bg-[#f1f1f1] ${activeProjectData.projectid ==
                                  eachList.projectid && projectCardOpen
                                  ? "border-[#2563eb] shadow-[0_0_0_3px_rgb(239,244,255)]"
                                  : "border-[#e2ddd8]"
                                  }`}
                                onClick={() => {
                                  projectDetail(eachList?.projectkey);
                                }}
                              >
                                <div className="cursor-pointer">
                                  <div className="">
                                    <div className="flex flex-col">
                                      <div className="text-[14px] leading-5 font-medium">
                                        {eachList?.invoiceid}
                                      </div>
                                      <div className="text-[12px] mt-1 text-[#8a8078] capitalize ">
                                        {eachList?.startdate}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mt-4 w-auto">
                                    <div
                                      className={`inline-block w-auto text-[11px] gap-2 px-3 py-[6px] rounded-full cursor-pointer transition-all duration-200 ${statusColor[eachList.status] || "bg-gray-100 text-gray-600 border border-gray-200"} hover:shadow-md `}
                                    >
                                      {eachList.status
                                        ? eachList.status
                                          ?.split("_")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                          .join(" ")
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="flex justify-center items-center h-full my-5">
                            <p className="text-sm text-gray-600 font-medium">
                              No Project Found
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div> */}

            {/* Middle Section */}

            <div
              // className="flex-1 flex flex-col gap-4  w-full h-full overflow-hidden min-w-0"
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <div className="flex-1 min-w-0  flex flex-col gap-4">
                <Card style={{ padding: 0 }}>
                  {/* Contact bar */}
                  <div
                    style={{
                      padding: "20px 24px",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                    }}
                  >
                    {/* <div
                      style={{
                        width: 52,
                        height: 52,
                        borderRadius: 14,
                        // borderRadius: 50,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: `linear-gradient(135deg, ${T.accent}, #8b5cf6)`,
                        color: "#fff",
                        fontSize: 18,
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {getInitials(leadDetail?.name) || "U"}
                    </div> */}
                    <Avatar
                      src={leadDetail?.userimg}
                      title={leadDetail?.name}
                      width="52px"
                      height="52px"
                      className={`!text-[#fff] !text-[18px] !font-bold !shrink-0 !bg-[linear-gradient(135deg,#6366f1,#8b5cf6)]`}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: T.text,
                          }}
                        >
                          {leadDetail?.name}
                        </span>
                        {Object.keys(activeDealData)?.length > 0 &&
                        MainIndex == 1 ? (
                          <div className="flex gap-2 items-center">
                            <Badge
                              color={
                                STATUS_COLORS[
                                  activeDealData?.current_stage?.dealstatus
                                ]
                              }
                            >
                              {activeDealData?.current_stage?.dealstatus}
                            </Badge>
                            {DealStatus !== "Won" && DealStatus !== "Lost" && (
                              <div className="flex gap-1 items-center">
                                <button
                                  onClick={() => {
                                    setWonFormDeal(activeDealData);
                                    setShowWonModal(true);
                                  }}
                                  title="Mark as Won"
                                  className={`p-2 rounded-full transition duration-200 hover:scale-110 
                                  bg-gray-100 hover:bg-green-200 text-green-600  
                  }`}
                                >
                                  <ThumbsUp className="size-4" />
                                </button>

                                <button
                                  onClick={() => {
                                    {
                                      setLostFormDeal({
                                        dealkey: activeDealData.dealkey,
                                        name: activeDealData.name,
                                      });
                                      setShowLostModal(true);
                                    }
                                  }}
                                  title="Mark as Lost"
                                  className={`p-2 rounded-full transition duration-200 hover:scale-110
                                    bg-gray-100 hover:bg-red-200 text-red-600  
                  }`}
                                >
                                  <ThumbsDown className="size-4" />
                                </button>
                              </div>
                            )}
                          </div>
                        ) : MainIndex == 2 ? (
                          <div
                            className={`inline-block w-auto text-[11px] font-bold gap-2 px-[10px] py-[3px] rounded-full cursor-pointer transition-all duration-200 
                                          hover:shadow-md `}
                            style={
                              statusColor[
                                activeProjectData?.status?.toLowerCase()
                              ] || {
                                background: "#f5f5f5",
                                color: "#616161",
                              }
                            }
                          >
                            {activeProjectData?.status
                              ? activeProjectData?.status
                                  ?.split("_")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")
                              : null}
                          </div>
                        ) : null}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 16,
                          marginTop: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        {[
                          {
                            icon: "phone",
                            text: leadDetail?.phone,
                            action: true,
                            phone: true,
                          },
                          {
                            icon: "mail",
                            text: leadDetail?.email,
                            action: true,
                            email: true,
                          },
                          { icon: "globe", text: leadDetail?.country },
                          { icon: "link", text: leadDetail?.page_source },
                        ].map((item, i) => (
                          <span
                            key={i}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              fontSize: 12,
                              color: item.action ? T.accentText : T.textMuted,
                              cursor: item.action ? "pointer" : "default",
                            }}
                          >
                            <Icon
                              name={item.icon}
                              size={12}
                              color={item.action ? T.accentText : T.textMuted}
                            />
                            {item?.email || item?.phone ? (
                              <a
                                href={
                                  item?.email
                                    ? `mailto:${item.text}`
                                    : item?.phone
                                      ? `tel:${item.text}`
                                      : ""
                                }
                              >
                                {item.text}
                              </a>
                            ) : (
                              item.text
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span style={{ fontSize: 12, color: T.textMuted }}>
                        Assigned
                      </span>
                      <div className="flex  gap-1 items-center">
                        <div className="relative " ref={assignedRef}>
                          <div
                            className="flex -space-x-2 cursor-pointer"
                            onClick={() => {
                              setShowAll(!showAll);
                              setShowDropdown(false);
                            }}
                          >
                            {leadDetail?.assigned_users
                              ?.slice(0, 3)
                              .map((user) => (
                                <>
                                  {/* <div
                                    style={{
                                      width: 34,
                                      height: 34,
                                      borderRadius: 100,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      background: "#6366f1" + "18",
                                      color: "#6366f1",
                                      fontSize: 12,
                                      fontWeight: 700,
                                      border: `2px solid #6366f130`,
                                    }}
                                  >
                                    {getInitials(user?.name)}
                                  </div> */}
                                  <Avatar
                                    src={user?.userimg}
                                    title={user?.name}
                                    width="34px"
                                    height="34px"
                                    className="border-2 !border-[#6366f130] !text-xs !font-bold !bg-[#6366f118] text-[#6366f1] shadow-sm "
                                  />
                                </>
                              ))}

                            {hiddenCount > 0 && (
                              <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#0057FB] text-white text-xs font-medium border-2 border-white shadow-sm">
                                +{hiddenCount}
                              </div>
                            )}
                          </div>

                          {showAll && (
                            <div className="absolute top-9   right-0 w-60 border border-[#f6f6f6]  bg-white rounded-xl shadow-xl p-3 z-30 overflow-hidden">
                              <div className="flex justify-between items-center mb-2  p-1 border-gray-400 border-b">
                                <h4 className="text-sm font-medium">
                                  Assigned Agents
                                </h4>
                                <button
                                  onClick={() => setShowAll(false)}
                                  className="p-1 rounded hover:bg-gray-100 transition"
                                >
                                  <X className="w-4 h-4 text-gray-500 hover:text-black" />
                                </button>
                              </div>

                              <div className="!overflow-y-auto w-full max-h-52  h-full">
                                {leadDetail?.assigned_users?.map(
                                  (each, idx) => (
                                    <div
                                      key={idx}
                                      className="flex items-center justify-between gap-2 p-1 hover:bg-slate-100 transition-all duration-300"
                                    >
                                      <AvatarProfile
                                        src={each?.userimg}
                                        title={each?.name}
                                        className="text-sm"
                                      />

                                      <span className="flex justify-end">
                                        <Tooltip
                                          key={`${idx}-unassigned`}
                                          className={`${Style.Tooltip}`}
                                          boxClassName={Style.TooltipBox}
                                          content="Delete"
                                          position={"bottom center"}
                                        >
                                          <div
                                            onClick={() => {
                                              deleteAssigned(each);
                                            }}
                                            className="p-2 text-red-600"
                                          >
                                            <Trash2 size={18} />
                                          </div>
                                        </Tooltip>
                                      </span>
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div>
                          <div
                            className="projectDetail-cardLeftUserAddBtn selectUser relative"
                            ref={assignedDropdownRef}
                          >
                            <button
                              className="bg-[#0057FB] h-8 w-8 text-white flex justify-center text-[12px] p-1 rounded-full items-center gap-1 selectUser-btn cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDropdown(!showDropdown);
                                setShowAll(false);
                              }}
                            >
                              {" "}
                              <Plus className="h-5 w-5" />
                            </button>

                            {showDropdown && (
                              <div className="selectUser-view customSearch mt-2 border border-[#f6f6f6] shadow-xl p-3 rounded-xl  bg-white w-64 absolute right-0  z-20">
                                <div className="selectUser-search flex items-center gap-2  mb-2 border-gray-400 border-b pb-1">
                                  <div className="icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask1"
                                        style={{ maskType: "alpha" }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="18"
                                      >
                                        <rect
                                          width="18"
                                          height="18"
                                          fill="#D9D9D9"
                                        ></rect>
                                      </mask>
                                      <g mask="url(#mask1)">
                                        <path
                                          d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                                          fill="#999999"
                                        ></path>
                                      </g>
                                    </svg>
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Search Agent..."
                                    className="customSearchInput border rounded px-2 py-1 w-full"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                  />
                                </div>

                                <div className="selectUser-list max-h-48 overflow-y-auto">
                                  <ul className="customSearchList ProjectAssignUsersList">
                                    {filteredUsers?.map((user) => (
                                      <li
                                        key={user?.userid}
                                        className="UserForAssign flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-100 rounded"
                                        onClick={() => {
                                          addAssigned(user);
                                        }}
                                      >
                                        <AvatarProfile
                                          src={user?.userimg}
                                          title={user?.name}
                                          className="text-sm"
                                        />
                                      </li>
                                    ))}
                                    {loadingUsers && (
                                      <li className="p-2 text-center text-gray-400 text-sm">
                                        Loading...
                                      </li>
                                    )}
                                    {filteredUsers?.length == 0 && (
                                      <li className="p-1 text-gray-400">
                                        No users found
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*Deal Stage Progress */}
                  {Object.keys(activeDealData).length > 0 && MainIndex == 1 ? (
                    <div
                      style={{
                        padding: "16px 24px 20px",
                        background: "rgba(0,0,0,0.015)",
                        borderTop: `1px solid ${T.cardBorder}`,
                      }}
                    >
                      <StageProgress
                        stages={STAGES}
                        activeDealData={activeDealData}
                        lastStage={
                          activeDealData?.stages?.length > 0
                            ? activeDealData?.stages[
                                activeDealData?.stages?.length - 2
                              ]
                            : ""
                        }
                        stageChange={() => {
                          getActiveDeal(activeDealData?.dealid);
                        }}
                      />
                    </div>
                  ) : null}

                  {/* Project Status Progress */}

                  {Object.keys(activeProjectData).length > 0 &&
                  MainIndex == 2 ? (
                    <div
                      style={{
                        padding: "16px 24px 20px",
                        background: "rgba(0,0,0,0.015)",
                        borderTop: `1px solid ${T.cardBorder}`,
                      }}
                    >
                      <StatusProgress
                        statusList={statusList}
                        activeProjectData={activeProjectData}
                        statusChange={() => {
                          getActiveProject(
                            activeProjectData?.projectkey ||
                              activeProjectData?.project_key,
                          );
                        }}
                      />
                    </div>
                  ) : null}
                </Card>
              </div>

              {MainIndex == 0 ? (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: 12,
                    }}
                  >
                    {leadDetail?.stats?.map((stat, i) => (
                      <Card key={i} style={{ padding: "14px 16px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: 11,
                                color: T.textMuted,
                                fontWeight: 500,
                                marginBottom: 4,
                              }}
                            >
                              {stat.label}
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: stat.color,
                              }}
                            >
                              {stat.value}
                            </div>
                          </div>
                          <div
                            style={{
                              width: 38,
                              height: 38,
                              borderRadius: 10,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: stat.color + "10",
                            }}
                          >
                            <Icon
                              name={stat.icon}
                              size={18}
                              color={stat.color}
                            />
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>

                  <Card
                    style={{
                      padding: "6px 8px",
                      display: "flex",
                      gap: 4,
                      flexWrap: "wrap",
                    }}
                  >
                    {renderedTabs}
                  </Card>

                  <div className="flex flex-col  h-screen overflow-auto">
                    {TAB_CONFIG.map(
                      (tabItem, index) =>
                        tab === index && (
                          <Suspense
                            key={tabItem?.key}
                            fallback={
                              <div className="tableDataLoader">
                                <div className="tableDataLoader-wrapper">
                                  <div className="loader"></div>
                                  <span>Data Load...</span>
                                </div>
                              </div>
                            }
                          >
                            {tabItem?.component}
                          </Suspense>
                        ),
                    )}
                  </div>
                </>
              ) : MainIndex == 1 ? (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: 12,
                    }}
                  >
                    {activeDealData?.stats?.map((stat, i) => (
                      <Card key={i} style={{ padding: "14px 16px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: 11,
                                color: T.textMuted,
                                fontWeight: 500,
                                marginBottom: 4,
                              }}
                            >
                              {stat.label}
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: stat.color,
                              }}
                            >
                              {stat.value}
                            </div>
                          </div>
                          <div
                            style={{
                              width: 38,
                              height: 38,
                              borderRadius: 10,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: stat.color + "10",
                            }}
                          >
                            <Icon
                              name={stat.icon}
                              size={18}
                              color={stat.color}
                            />
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>

                  <DealInfo
                    DealStages={DealStages}
                    UserList={UsersList}
                    leadDetail={leadDetail}
                    activeDealData={activeDealData}
                    loading={dealDataLoading}
                    clientDeals={clientDeals}
                    onSuccess={onSuccess}
                    onError={onError}
                    updateData={updateData}
                    reloadData={() => {
                      getActiveDeal(activeDealData?.dealid);
                    }}
                    onFollowUpSuccess={onFollowUpSuccess}
                    updateCount={updateCount}
                    followUp={condition2}
                    followUpID={followUpID}
                  />
                </>
              ) : MainIndex == 2 ? (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: 12,
                    }}
                  >
                    {activeProjectData?.stats?.map((stat, i) => (
                      <Card key={i} style={{ padding: "14px 16px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: 11,
                                color: T.textMuted,
                                fontWeight: 500,
                                marginBottom: 4,
                              }}
                            >
                              {stat.label}
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: stat.color,
                              }}
                            >
                              {stat.value}
                            </div>
                          </div>
                          <div
                            style={{
                              width: 38,
                              height: 38,
                              borderRadius: 10,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: stat.color + "10",
                            }}
                          >
                            <Icon
                              name={stat.icon}
                              size={18}
                              color={stat.color}
                            />
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>

                  <ProjectTab
                    leadDetail={leadDetail}
                    activeProjectData={activeProjectData}
                    loading={projectDataLoading}
                    onSuccess={onSuccess}
                    onError={onError}
                    updateProjectData={updateProjectData}
                    clientProjects={clientProjects}
                    loadActiveProject={() => {
                      getActiveProject(activeProjectData?.projectkey);
                    }}
                    UsersList={UsersList}
                    onFollowUpSuccess={onFollowUpSuccess}
                    updateCount={updateCount}
                    followUp={condition2}
                    followUpID={followUpID}
                  />
                </>
              ) : null}
            </div>

            <div
              style={{
                width: 260,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              <div
                className={`
                transition-all duration-300 ease-in-out shrink-0  w-full [scrollbar-width:none]
        [&::-webkit-scrollbar]:hidden
        [&_*::-webkit-scrollbar]:hidden
        [&_*]:[scrollbar-width:none]
              `}
              >
                <div className="flex flex-col gap-1 overflow-hidden overflow-y-auto h-full">
                  {condition !== "contact" ? (
                    <div className="rounded-[10px] bg-white border border-[#E1E4EA] py-[8px] px-[8px] flex-shrink-0">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center  gap-[10px] w-full">
                          {[{ label: "Deals" }, { label: "Projects" }].map(
                            (item, idx) => {
                              const activeleftBar = idx === leftTabIndex; // first tab active

                              return (
                                <button
                                  key={idx}
                                  className={`px-[25px] py-[7px] w-full flex items-center justify-center gap-1 text-[14px] text-[#414651] font-medium rounded-[7px] transition-all
                                  ${
                                    activeleftBar
                                      ? "bg-[#6366f1] text-[#fff] font-[500]"
                                      : "text-[#8a8078]"
                                  }    
                                                            `}
                                  onClick={() => {
                                    setLeftTabIndex(idx);
                                  }}
                                >
                                  <span>{item.label}</span>
                                </button>
                              );
                            },
                          )}
                        </div>
                      </div>
                    </div>
                  ) : condition == "contact" ? (
                    <div className="rounded-[10px] bg-white border border-[#E1E4EA] py-[8px] px-[8px] flex-shrink-0">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center  gap-[10px] w-full">
                          {[{ label: "Deals" }].map((item, idx) => {
                            const activeleftBar = idx === leftTabIndex; // first tab active

                            return (
                              <button
                                key={idx}
                                className={`px-[25px] py-[7px] w-full flex items-center justify-center gap-1 text-[14px] text-[#414651] font-medium rounded-[7px] transition-all
                                  ${
                                    activeleftBar
                                      ? "bg-[#6366f1] text-[#fff] font-[500]"
                                      : "text-[#8a8078]"
                                  }    
                                                            `}
                                onClick={() => {
                                  setLeftTabIndex(idx);
                                }}
                              >
                                <span>{item.label}</span>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {leftTabIndex == 0 ? (
                    <>
                      <div className="gap-y-[10px] h-full max-h-[223px] rounded-[10px] overflow-hidden">
                        <div className="flex flex-col gap-y-[10px] h-full  min-h-0  overflow-auto">
                          {clientDeals?.map((eachList, i) => {
                            return (
                              <div
                                key={eachList?.dealid}
                                ref={(el) =>
                                  (dealRefs.current[eachList?.dealid] = el)
                                }
                                className={`p-[14px] rounded-[10px] cursor-pointer border bg-white transition-all duration-200 hover:bg-[#f1f1f1]  ${
                                  activeDealData.dealid == eachList.dealid &&
                                  dealCardOpen
                                    ? "border-[#6366f1] shadow-[0_0_0_3px_rgb(239,244,255)]"
                                    : "border-[#e2ddd8]"
                                }`}
                                onClick={() => {
                                  dealDetail(eachList?.dealid);
                                }}
                              >
                                <div className="cursor-pointer">
                                  <div className="flex gap-x-1">
                                    <div className="flex flex-col">
                                      <div className="text-[14px] leading-5 font-medium">
                                        {eachList?.name}
                                      </div>
                                      <div className="text-[12px] mt-1 text-[#8a8078] capitalize">
                                        {eachList?.deal_package_name}
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="mt-4">
                                    {eachList?.current_stage?.dealstatus ==
                                    "Need Analysis" ? (
                                      <Chip
                                        color={"yellow"}
                                        className="text-nowrap !text-[11px] cursor-pointer"
                                      >
                                        Need Analysis
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Value Proposition" ? (
                                      <Chip
                                        color="blue"
                                        className="text-nowrap !text-[11px] cursor-pointer"
                                      >
                                        Value Proposition
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Identify Decision" ? (
                                      <Chip
                                        color="violet"
                                        className="text-nowrap !text-[11px] cursor-pointer"
                                      >
                                        Identify Decision
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Proposal" ? (
                                      <Chip
                                        color="teal"
                                        className="!text-[11px] cursor-pointer"
                                      >
                                        Proposal
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Review" ? (
                                      <Chip
                                        color="indigo"
                                        className="!text-[11px] cursor-pointer"
                                      >
                                        Review
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Won" ? (
                                      <Chip
                                        color="green"
                                        className="!text-[11px] cursor-pointer"
                                      >
                                        Won
                                      </Chip>
                                    ) : eachList?.current_stage?.dealstatus ==
                                      "Lost" ? (
                                      <Chip
                                        color="red"
                                        className="!text-[11px] cursor-pointer"
                                      >
                                        Lost
                                      </Chip>
                                    ) : (
                                      <Chip
                                        color="gray"
                                        className="!text-[11px] cursor-pointer"
                                      >
                                        {eachList?.current_stage?.dealstatus ||
                                          "--"}
                                      </Chip>
                                    )}
                                  </div> */}
                                  <div className="mt-4">
                                    <Badge
                                      color={
                                        STATUS_COLORS[
                                          eachList?.current_stage?.dealstatus
                                        ]
                                      }
                                    >
                                      {eachList?.current_stage?.dealstatus}
                                    </Badge>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  ) : leftTabIndex == 1 ? (
                    <>
                      <div className="gap-y-[10px] h-full max-h-[223px] rounded-[10px] overflow-hidden">
                        <div className="flex flex-col gap-y-[10px]  h-full min-h-0  overflow-auto ">
                          {clientProjects?.length > 0 ? (
                            clientProjects?.map((eachList, i) => {
                              return (
                                <div
                                  key={eachList?.projectid}
                                  ref={(el) =>
                                    (projectRefs.current[eachList?.projectid] =
                                      el)
                                  }
                                  className={`p-[14px] rounded-[10px] cursor-pointer border bg-white transition-all duration-200 hover:bg-[#f1f1f1] ${
                                    activeProjectData?.projectid ==
                                      eachList.projectid && projectCardOpen
                                      ? "border-[#6366f1] shadow-[0_0_0_3px_rgb(239,244,255)]"
                                      : "border-[#e2ddd8]"
                                  }`}
                                  onClick={() => {
                                    projectDetail(eachList?.projectkey);
                                  }}
                                >
                                  <div className="cursor-pointer">
                                    <div className="">
                                      <div className="flex flex-col">
                                        <div className="text-[14px] leading-5 font-medium">
                                          {eachList?.invoiceid}
                                        </div>
                                        <div className="text-[12px] mt-1 text-[#8a8078] capitalize ">
                                          {eachList?.startdate}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="mt-4 w-auto">
                                      <div
                                        className={`inline-block w-auto text-[11px] font-bold gap-2 px-[10px] py-[3px] rounded-full cursor-pointer transition-all duration-200 
                                           `}
                                        style={
                                          statusColor[
                                            eachList?.status?.toLowerCase()
                                          ] || {
                                            background: "#f5f5f5",
                                            color: "#616161",
                                          }
                                        }
                                      >
                                        {/* ${statusColor[eachList.status] || "bg-gray-100 text-gray-600 border border-gray-200"}  */}
                                        {eachList.status
                                          ? eachList.status
                                              ?.split("_")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1),
                                              )
                                              .join(" ")
                                          : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="flex justify-center items-center h-full my-5">
                              <p className="text-sm text-gray-600 font-medium">
                                No Project Found
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>

              {/* QUICK ACTIONS */}
              <Card style={{ padding: 16 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: T.textMuted,
                    letterSpacing: "1px",
                    marginBottom: 12,
                    textTransform: "uppercase",
                  }}
                >
                  Quick Actions
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <ActionButton
                    icon="phone"
                    label="Log a Call"
                    color="#3b82f6"
                    variant="filled"
                    onClick={() => {
                      setLogType("call");
                      setShowLogModal(true);
                    }}
                  />
                  <ActionButton
                    icon="mail"
                    label="Send Email"
                    color="#8b5cf6"
                  />
                  <ActionButton icon="sms" label="Send SMS" color="#06b6d4" />
                  <ActionButton
                    icon="plus"
                    label="Add Deal"
                    color="#3b82f6"
                    variant="8b5cf6"
                    onClick={() => {
                      setShowAddDealModal(true);
                    }}
                  />
                  <ActionButton
                    icon="calendar"
                    label="Schedule Follow Up"
                    color="#f59e0b"
                    onClick={() => {
                      if (typeof setSelectedActivity === "function") {
                        setSelectedActivity(null);
                      }
                      if (typeof setShowActivityModal === "function") {
                        setShowActivityModal(true);
                      }
                      setMenuOpen(false);
                    }}
                  />

                  {/* {DealStatus != "Won" &&
                  DealStatus != "Lost" &&
                  Object.keys(activeDealData)?.length > 0 &&
                  MainIndex == "1" ? (
                    <div className="flex gap-2">
                      <ActionButton
                        icon="thumbsUp"
                        label="Won"
                        color="#22c55e"
                        variant="16a34a"
                        onClick={() => {
                          setWonFormDeal(activeDealData);
                          setShowWonModal(true);
                        }}
                      />

                      <ActionButton
                        icon="thumbsDown"
                        label="Lost"
                        color="#ef4444"
                        variant="dc2626"
                        onClick={() => {
                          {
                            setLostFormDeal({
                              dealkey: activeDealData.dealkey,
                              name: activeDealData.name,
                            });
                            setShowLostModal(true);
                          }
                        }}
                      />
                    </div>
                  ) : null} */}

                  {/* <ActionButton
                    icon="arrowRight"
                    label="Move to Next Stage"
                    color="#22c55e"
                    onClick={() =>
                      currentStageIndex < STAGES.length - 1 &&
                      setCurrentStageIndex((i) => i + 1)
                    }
                  /> */}
                </div>
              </Card>

              {/* DEAL HEALTH */}
              {/* <Card style={{ padding: 16 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: T.textMuted,
                    letterSpacing: "1px",
                    marginBottom: 14,
                    textTransform: "uppercase",
                  }}
                >
                  Deal Health
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 12 }}
                >
                  <HealthGauge
                    label="Win Probability"
                    value={leadDetail?.deal_health_data?.engagement}
                    color="#3b82f6"
                  />
                  <HealthGauge
                    label="Stage Progress"
                    value={leadDetail?.deal_health_data?.stage_progress}
                    color="#f59e0b"
                  />
                  <HealthGauge
                    label="Engagement"
                    value={leadDetail?.deal_health_data?.win_probability}
                    color="#22c55e"
                  />
                </div>
                {leadDetail?.deal_health_data?.insights && (
                  <div
                    style={{
                      marginTop: 14,
                      padding: "10px 12px",
                      background: "#f59e0b0a",
                      border: "1px solid #f59e0b20",
                      borderRadius: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginBottom: 4,
                      }}
                    >
                      <Icon name="alertCircle" size={13} color="#f59e0b" />
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#f59e0b",
                        }}
                      >
                        Insight
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: 11,
                        color: T.textSecondary,
                        lineHeight: 1.4,
                      }}
                    >
                      {leadDetail?.deal_health_data?.insights}
                    </span>
                  </div>
                )}
              </Card> */}

              {/* UPCOMING */}

              {leadDetail?.next_schedules.length > 0 && (
                <Card style={{ padding: 16 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: T.textMuted,
                      letterSpacing: "1px",
                      marginBottom: 12,
                      textTransform: "uppercase",
                    }}
                  >
                    Next Up
                  </div>
                  <div className="w-full h-full max-h-24 overflow-auto ">
                    {leadDetail?.next_schedules
                      ?.filter((f) => f?.status === "pending")
                      // ?.slice(0, 2)
                      ?.map((f, i) => (
                        <div
                          key={f.id}
                          style={{
                            padding: "10px 4px",
                            borderBottom:
                              leadDetail?.next_schedules?.length - 1 > i
                                ? `1px solid ${T.cardBorder}`
                                : null,
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              background: priorityColors[f.priority],
                              boxShadow: `0 0 0 3px ${priorityColors[f.priority]}20`,
                            }}
                          />
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: T.text,
                              }}
                            >
                              {f?.note}
                            </div>
                            <div style={{ fontSize: 11, color: T.textMuted }}>
                              {f?.due_date} · {f?.due_time}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Card>
              )}

              {/* RECENT ACTIVITY SNAPSHOT */}
              {/* <Card style={{ padding: 16 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: T.textMuted,
                    letterSpacing: "1px",
                    marginBottom: 12,
                    textTransform: "uppercase",
                  }}
                >
                  Activity Snapshot
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                  }}
                >
                  {[
                    {
                      label: "Calls",
                      value: leadDetail?.snapshot_data?.Calls,
                      color: "#3b82f6",
                    },
                    {
                      label: "Emails",
                      value: leadDetail?.snapshot_data?.Emails,
                      color: "#8b5cf6",
                    },
                    {
                      label: "SMS",
                      value: leadDetail?.snapshot_data?.SMS,
                      color: "#06b6d4",
                    },
                    {
                      label: "Deals",
                      value: leadDetail?.snapshot_data?.Deals,
                      color: "#f59e0b",
                    },
                  ].map((s, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "8px 10px",
                        background: s.color + "08",
                        borderRadius: 8,
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 700,
                          color: s.color,
                        }}
                      >
                        {s.value}
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          color: T.textMuted,
                          fontWeight: 500,
                        }}
                      >
                        {s.label}
                      </div>
                    </div>
                  ))}
                </div>
              </Card> */}
            </div>
          </div>
        </div>
      )}

      {showActivityModal && (
        <FollowUpPopup
          onClose={() => {
            setShowActivityModal(false);
          }}
          CustomerData={{
            entity_type:
              MainIndex == "2"
                ? "project"
                : MainIndex == "1"
                  ? "deal"
                  : condition == "account"
                    ? "contact"
                    : condition,
            entity_name:
              MainIndex == "2"
                ? activeProjectData?.name
                : MainIndex == "1"
                  ? activeDealData.name
                  : leadDetail.name,
            entity_id:
              MainIndex == "2"
                ? activeProjectData?.projectid
                : MainIndex == "1"
                  ? activeDealData?.dealid
                  : leadDetail?.userid,
          }}
          tabIndex={2}
          onError={onError}
          onSubmit={onFollowUpSuccess}
          // id={leadDetail?.userid}
          // entitytype={condition}
          // entityname={leadDetail.name}
          UsersList={UsersList}
        />
      )}

      {showAddDealModal && (
        <EmployeeDirectoryAddUpdate
          open={showAddDealModal}
          onClose={() => {
            setShowAddDealModal(false);
          }}
          data={{ contactid: leadDetail?.userid }}
          tabIndex={1}
          contactId={leadDetail?.userid}
          onDealUpdated={() => getData()} // refresh after update
          onSubmit={dealSuccess}
          onError={onError}
          fromInnerPage={true}
          type={condition == "account" ? "account" : "contact"}
        />
      )}

      {showLead && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowLead(false);
            setCurrentData({});
          }}
          data={currentData}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onSubmit={updateDealSuccess}
          onError={onError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={updateDealSuccess}
          onError={onError}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>

      {show && (
        <CustomizeTabsOverviewPopup
          data={TAB_CONFIG.map((t) => t)}
          tabs={tabsCustomizeTabs}
          onClose={() => setShow(false)}
          onToggle={(tabName) => {
            if (tabName === "details") return; //
            setTabsCustomizeTabs((prev) => ({
              ...prev,
              [tabName]: !prev[tabName],
            }));
            handleTabChange(0);
          }}
        />
      )}
    </>
  );
}
